class PermissionService {
  userData: any = JSON.parse(localStorage.getItem(`oidc.user:${(window as any).API_FINX_AUTH}:portal-client-2`) as string)

  hasPermission(permission: string) {
    if (this.permissions) {
      return !!this.permissions.find(elem => elem === permission || elem === '*')
    }
    return false
  }

  get permissions() {
    if (this.userData && this.userData.profile && this.userData.profile.permissoes) {
      const permissions = this.userData.profile.permissoes

      // Check when is an string. This is needed when user has just one permission
      // Convert string to an array
      if (typeof permissions === 'string') {
        return [permissions]
      }

      return permissions
    }
    return []
  }
}

// eslint-disable-next-line import/prefer-default-export
export const permissionService = new PermissionService()
